import { apiClient } from "@/api/api-client";
import createBaseService from "@/api/base-service.ts";
import type { CaseCollaborator, UserCanPostFormSchema } from "../../types/case-collaborator";

const caseCollaboratorService = {
	...createBaseService<CaseCollaborator>("/backoffice/case-collaborators"),

	updateCanPostById: async (data: UserCanPostFormSchema) => {
		const response = await apiClient.put<{ data: UserCanPostFormSchema }>(`/backoffice/case-collaborators/${data.id}/update-can-post`, data);

		return response.data.data;
	},
};

export default caseCollaboratorService;
